module.exports = __webpack_public_path__ + "static/media/online-laakari-asiakas-mobiili.8a8cb7a4.png";